import { IAppState } from '../../common/state';

export function selectNewbuildingBrokerConsultantBannerAvailable(state: IAppState) {
  return state.featureToggle.isNewbuildingBrokerConsultantBannerEnabled;
}
